//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    item: Object,
    isBlacklisted: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  watch: {
    item: function item(_item, oldItem) {
      this.loadResident(_item);
    }
  },
  data: function data() {
    return {
      balance: 0,
      loading: true
    };
  },
  created: function created() {
    Event.$on("update-resident-detail", this.updateResident);
    Event.$on("update-resident-balance", this.updateBalance);
  },
  beforeDestroy: function beforeDestroy() {
    Event.$off("update-resident-detail");
    Event.$off("update-resident-balance");
  },

  computed: {
    hideInProd: function hideInProd() {
      return window.validator.hideInProd();
    },
    statusLabel: function statusLabel() {
      switch (this.item.current_status ? this.item.current_status.toLowerCase() : this.item.current_status) {
        case "notice":
          return "On Notice";
        case "move out":
          return "Moved Out";
        case "future":
          return "Future";
        case "active":
        default:
          return "Active";
      }
    },
    setStatusClass: function setStatusClass() {
      return "status_" + (this.item.current_status ? this.item.current_status.toLowerCase().replace(/\s/g, "") : "");
    },
    setPortalClass: function setPortalClass() {
      return this.isBlacklisted ? 'PORTAL_COLOR_YES' : 'PORTAL_COLOR_NO';
    }
  },
  methods: {
    loadResident: function loadResident(item) {
      var $el = this;
      $el.residentLease = null;

      // @TODO: I think there is a bit of a timing issue going on - you'll see in DevTools w/ leases

      // format dates
      var list = item.leases;

      if (list) {
        for (var i = 0; i < list.length; i++) {
          if (list[i].move_in_date) {
            list[i].move_in_date = this.dateFilter(list[i].move_in_date);
          }
          if (list[i].move_out_date) {
            list[i].move_out_date = this.dateFilter(list[i].move_out_date);
          }
          if (list[i].lease_expiration_date) {
            list[i].lease_expiration_date = this.dateFilter(list[i].lease_expiration_date);
          }
        }
      }

      item.leases = list;

      if (item.move_in_date) {
        item.move_in_date = this.dateFilter(item.move_in_date);
      }
      if (item.move_out_date) {
        item.move_out_date = this.dateFilter(item.move_out_date);
      }
      if (item.notification_date) {
        item.notification_date = this.dateFilter(item.notification_date);
      }

      var residentLeases = item.leases;

      if (residentLeases) {
        for (var _i = 0; _i < residentLeases.length; _i++) {
          // set residentLease
          if (residentLeases[_i].is_active == 1) {
            $el.residentLease = residentLeases[_i];
          }
        }

        //if no active leases, use a future lease
        if (!$el.residentLease) {
          for (var _i2 = 0; _i2 < residentLeases.length; _i2++) {
            if (residentLeases[_i2].lease_start_date > moment().format("YYYY-MM-DD")) {
              $el.residentLease = residentLeases[_i2];
            }
          }
        }
      }

      // is this the way? this whole thing seems dodgy. `item` is a prop, but everything is
      // built this way & accessing `item`
      item.lease = $el.residentLease;
      this.item = item;

      Vue.nextTick().then(function () {
        Event.$emit("tab-type", "Dashboard");
        Event.$emit("refresh-resident-dashboard");
        Event.$emit("update-resident-balance");
      });

      $el.loading = false;
    },
    updateResident: function updateResident() {
      var _this = this;

      axios.get("/prototype/resident/" + this.item.id).then(function (response) {
        _this.item.person = response.data.person;
        _this.item.n_s_f_payment_meta = response.data.n_s_f_payment_meta;
      });
    },
    updateBalance: function updateBalance() {
      var _this2 = this;

      axios.post("/prototype/resident/ledger/balance", { id: this.item.id }).then(function (response) {
        return _this2.balance = response.data;
      });
    },
    addNotes: function addNotes() {
      Event.$emit("resident-add-notes");
    },
    dateFilter: function dateFilter(value) {
      if (moment(value).isValid()) return moment(value).format("MM/DD/YYYY");
    },
    showNoticeDetails: function showNoticeDetails() {
      Event.$emit("notice-to-vacate-summary");
    },
    showMoveOutDetails: function showMoveOutDetails() {
      Event.$emit("moveout-summary");
    },
    showNSFDetails: function showNSFDetails() {
      Event.$emit("nsf-summary");
    },
    leaseInformation: function leaseInformation() {
      Event.$emit("reset-lease-tab");
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/ResidentOverview.vue
// module id = agnF
// module chunks = 0 1